import React from "react";

export default function Galery() {
  return (
    <div className="container mt-20">
      <div className="grid grid-cols-3 gap-4 px-2">
        <div className="col-span-1">
          <img
            src={require("../../images/test-1.jpg")}
            alt="Gambar 1"
            className="w-96 mx-auto rounded"
          />
          <div className="md:pl-16">
            <p className="text-xs text-slate-400">May 8, 2014</p>
            <h5 className="font-bold text-sm text-center md:text-left md:text-xl text-green-700">
              Lorem ipsum dolor sit amet.
            </h5>
          </div>
        </div>

        <div className="col-span-1">
          <img
            src={require("../../images/test-2.jpg")}
            alt="Gambar 1"
            className="w-96 mx-auto rounded"
          />
          <div className="md:pl-16">
            <p className="text-xs text-slate-400">May 7, 2014</p>
            <h5 className="font-bold text-sm text-center md:text-left md:text-xl text-green-700">
              Lorem ipsum dolor sit amet.
            </h5>
          </div>
        </div>

        <div className="col-span-1">
          <img
            src={require("../../images/test-3.jpg")}
            alt="Gambar 1"
            className="w-96 mx-auto rounded"
          />
          <div className="md:pl-16">
            <p className="text-xs text-slate-400">May 6, 2014</p>
            <h5 className="font-bold text-sm text-center md:text-left md:text-xl text-green-700">
              Lorem ipsum dolor sit amet.
            </h5>
          </div>
        </div>
      </div>

      <div className="text-center mt-5">
        <p className="text-xs text-slate-400">
          Lorem ipsum dolor sit amet consectetur{" "}
          <span className="text-green-700">adipisicing elit.</span> Ipsum sed
          eum earum vitae dicta repudiandae repellendus quo rerum tenetur amet!
        </p>

        <button
          type="button"
          className="w-96 mt-3 focus:outline-none text-white bg-lime-500 hover:bg-lime-800 focus:ring-4 focus:ring-green-300 font-medium rounded text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
        >
          Read Our Blog
        </button>
      </div>
    </div>
  );
}
